<template>
  <div class="details-popover">
    <div v-loading="loading" element-loading-spinner="nucleus-loader" style="min-height: 280px;">
      <div v-if="!loading">
        <div v-if="!isCoding">
          <el-table style="height: 280px;" v-show="tableType === 'binary' || tableType === 'stats'" :data="popOverData">
            <el-table-column prop="title" :label="header"> </el-table-column>
            <el-table-column prop="value" label="">
              <template slot-scope="scope">
                <div v-if="scope.row.title === 'RVU Difference'" :class="scope.row.value < 0 ? 'negativeNumber' : ''">
                  {{ scope.row.value }}
                </div>
                <div v-else-if="(scope.row.title === 'Original Work RVU' && scope.row.value === null) || (scope.row.title === 'Recommended Work RVU' && scope.row.value === null)">
                  N/A
                </div>
                <div v-else :class="canOpenDetails(scope.row) ? 'details' : ''" :title="canOpenDetails(scope.row) ? 'View Records and Worksheets' : ''" @click="canOpenDetails(scope.row) && handleFilterClick(scope.row)">{{ scope.row.value }}</div>
              </template>
            </el-table-column>
          </el-table>

          <el-table style="height: auto;" v-show="tableType === 'financial'" :data="popOverData">
            <el-table-column prop="title" :label="header" width="210"> </el-table-column>
            <el-table-column prop="value" label="">
              <template slot-scope="scope">
                <div v-if="scope.row.title !== 'Reimbursement Decrease Records' && scope.row.title !== 'Reimbursement Increase Records'" :class="scope.row.value < 0 ? 'negative' : ''">${{ formatMoney(scope.row.value) }}</div>
                <div v-else :class="canOpenDetails(scope.row) ? 'details' : ''" :title="canOpenDetails(scope.row) ? 'View Records and Worksheets' : ''" @click="canOpenDetails(scope.row) && handleFilterClick(scope.row)">{{ scope.row.value }}</div>
              </template>
            </el-table-column>
          </el-table>

          <el-table style="height: auto;" v-show="tableType === 'dataStats'" :data="popOverData">
            <el-table-column prop="title" :label="header" width="210"> </el-table-column>
            <el-table-column prop="value" label="">
              <template slot-scope="scope">
                <div v-if="scope.row.title !== 'Number of Records' && scope.row.title !== 'Record Recommendations'" :class="scope.row.value < 0 ? 'negative' : ''">${{ formatMoney(scope.row.value) }}</div>
                <div v-else :class="canOpenDetails(scope.row) ? 'details' : ''" :title="canOpenDetails(scope.row) ? 'View Records and Worksheets' : ''" @click="canOpenDetails(scope.row) && handleFilterClick(scope.row)">{{ scope.row.value }}</div>
              </template>
            </el-table-column>
          </el-table>

          <el-table style="height: auto;" v-show="tableType === 'proDataStats'" :data="popOverData">
            <el-table-column prop="title" :label="header" width="210"> </el-table-column>
            <el-table-column prop="value" label="">
              <template slot-scope="scope">
                <div v-if="scope.row.title === 'RVU Difference'" :class="scope.row.value < 0 ? 'negativeNumber' : ''">
                  {{ scope.row.value }}
                </div>
                <div v-else-if="(scope.row.title === 'Original Work RVU' && scope.row.value === null) || (scope.row.title === 'Recommended Work RVU' && scope.row.value === null)">
                  N/A
                </div>
                <div v-else :class="canOpenDetails(scope.row) ? 'details' : ''" :title="canOpenDetails(scope.row) ? 'View Records and Worksheets' : ''" @click="canOpenDetails(scope.row) && handleFilterClick(scope.row)">{{ scope.row.value }}</div>
              </template>
            </el-table-column>
          </el-table>

          <small v-if="header === 'Total Codes' && reviewType === 'ip'" style="font-style: italic; margin: 5px 0px 0px 10px; display: inline-block;">*Total Codes is calculated using CM and PCS codes</small>

          <small v-if="header === 'Total Codes' && reviewType === 'op'" style="font-style: italic; margin: 5px 0px 0px 10px; display: inline-block;">*Total Codes is calculated using CM, PCS, CPT, MOD, E/M, I&I and S&I codes</small>

          <small v-if="header === 'Total Codes' && reviewType === 'pro'" style="font-style: italic; margin: 5px 0px 0px 10px; display: inline-block;">*Total Codes is calculated using CM, E/M, CPT and Modifier codes</small>

          <div v-show="reviewType === 'ip' && ['additionsAccounts', 'deletionsAccounts', 'noRecAccounts', 'accountNumbers'].some(s => s === tableType)">
            <div class="details-popover-title" style="float: left; text-align: left; margin: 0px 0px 10px 10px;">Account Numbers for {{ header }}</div>
            <div style="float: right; margin: 0px 0px 0px 0px;">
              <el-button @click="handleArrayToCsv()" plain><i class="mdi mdi-file-download-outline tableIcon"></i>Download CSV </el-button>
            </div>
            <div style="float: right; margin: 0px 10px 10px 0px;">
              <el-input prefix-icon="el-icon-search" size="mini" placeholder="Search Query..." type="text" class="globalSearch" v-model="filterCriteria"> </el-input>
            </div>
            <el-table :data="isIE11 ? filterList(dashboardAccountsPagination, filterCriteria, ['dschDate', 'patNum', 'payName', 'description', 'orDrg', 'neDrg']).sort(sortByOrder) : filterList(localDashboardAccounts, filterCriteria, ['dschDate', 'patNum', 'payName', 'description', 'orDrg', 'neDrg']).sort(sortByOrder)" height="280px" ref="ipList">
              <el-table-column prop="patNum" label="Patient Number">
                <template slot-scope="scope">
                  <template v-if="$route.name === 'my-projects'">
                    <router-link :to="`/${currentClientId}/my-projects/inpatient/${scope.row.drgtableId}`">{{ scope.row.patNum }}</router-link>
                  </template>
                  <template v-else>
                    <div v-html="highlightValue(scope.row.patNum, filterCriteria)"></div>
                  </template>
                </template>
              </el-table-column>
              <el-table-column prop="payName" label="Payor">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.payName, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="dschDate" label="Discharge Date">
                <template slot-scope="scope">
                  <div v-html="highlightValue(formatDate(scope.row.dschDate), filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="rfc" label="Reason For Change">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.description, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="facDRG" label="Facility DRG">
                <template slot-scope="scope">
                  <div :title="scope.row.orDrgDesc" v-html="highlightValue(scope.row.orDrgDisplay, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="hiaDrg" label="HIA DRG">
                <template slot-scope="scope">
                  <div :title="scope.row.neDrgDesc" v-html="highlightValue(scope.row.neDrgDisplay, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column>
                <template slot-scope="scope">
                  <el-button @click="handleViewWorksheets(scope.row)" plain><i class="mdi mdi-open-in-new tableIcon"></i>Worksheet </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div id="accountNumberTableStats">
              <p>{{ accountNumberTableStats() }}</p>
            </div>

            <el-pagination class="pager" v-if="isIE11" background :pager-count="15" layout="prev, pager, next, slot" :page-size="itemsPerPage" :total="localDashboardAccounts.length" @current-change="handleCurrentChange" :hide-on-single-page="hideOnSinglePage" small> </el-pagination>
          </div>

          <div v-show="reviewType === 'op' && tableType === 'accountNumbers'">
            <div class="details-popover-title" style="float: left;text-align: left; margin: 0px 0px 10px 10px;">Account Numbers for {{ header }}</div>
            <div style="float: right; margin: 0px 0px 0px 0px;">
              <el-button @click="handleArrayToCsv()" plain><i class="mdi mdi-file-download-outline tableIcon"></i>Download CSV </el-button>
            </div>
            <div style="float: right; margin: 0px 10px 10px 0px;">
              <el-input prefix-icon="el-icon-search" size="mini" placeholder="Search Query..." type="text" class="globalSearch" v-model="filterCriteria"> </el-input>
            </div>
            <el-table :data="isIE11 ? filterList(dashboardAccountsPagination, filterCriteria).sort(sortByOrder) : filterList(localDashboardAccounts, filterCriteria).sort(sortByOrder)" height="280px" ref="opList">
              <el-table-column prop="patNum" label="Patient Number">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.patNum, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="patType" label="Patient Type">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.patType, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="payName" label="Payor">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.payName, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="servDate" label="Date of Service">
                <template slot-scope="scope">
                  <div v-html="highlightValue(formatDate(scope.row.servDate), filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="rfc" label="Reason For Change">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.changeDesc, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column>
                <template slot-scope="scope">
                  <el-button @click="handleViewWorksheets(scope.row)" plain><i class="mdi mdi-open-in-new tableIcon"></i>Worksheet </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div id="accountNumberTableStats">
              <p>{{ accountNumberTableStats() }}</p>
            </div>
            <el-pagination class="pager" v-if="isIE11" background :pager-count="15" layout="prev, pager, next, slot" :page-size="itemsPerPage" :total="localDashboardAccounts.length" @current-change="handleCurrentChange" :hide-on-single-page="hideOnSinglePage" small> </el-pagination>
          </div>

          <div v-show="reviewType === 'pro' && tableType === 'accountNumbers'">
            <div class="details-popover-title" style="float: left;text-align: left; margin: 0px 0px 10px 10px;">Account Numbers for {{ header }}</div>
            <div style="float: right; margin: 0px 0px 0px 0px;">
              <el-button @click="handleArrayToCsv()" plain><i class="mdi mdi-file-download-outline tableIcon"></i>Download CSV </el-button>
            </div>
            <div style="float: right; margin: 0px 10px 10px 0px;">
              <el-input prefix-icon="el-icon-search" size="mini" placeholder="Search Query..." type="text" class="globalSearch" v-model="filterCriteria"> </el-input>
            </div>
            <el-table :data="isIE11 ? filterList(dashboardAccountsPagination, filterCriteria).sort(sortByOrder) : filterList(localDashboardAccounts, filterCriteria).sort(sortByOrder)" height="280px" ref="opList">
              <el-table-column prop="patNum" label="Patient Number">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.patNum, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="patType" label="Patient Type">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.patType, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="payName" label="Payor">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.payName, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="servDate" label="Date of Service">
                <template slot-scope="scope">
                  <div v-html="highlightValue(formatDate(scope.row.servDate), filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="rfc" label="Reason For Change">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.changeDesc, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column>
                <template slot-scope="scope">
                  <el-button @click="handleViewWorksheets(scope.row)" plain><i class="mdi mdi-open-in-new tableIcon"></i>Worksheet </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div id="accountNumberTableStats">
              <p>{{ accountNumberTableStats() }}</p>
            </div>
            <el-pagination class="pager" v-if="isIE11" background :pager-count="15" layout="prev, pager, next, slot" :page-size="itemsPerPage" :total="localDashboardAccounts.length" @current-change="handleCurrentChange" :hide-on-single-page="hideOnSinglePage" small> </el-pagination>
          </div>

          <div v-show="tableType === 'dxDashboard'">
            <div class="details-popover-title" style="float: left;text-align: left; margin: 0px 0px 10px 10px;">Dx Summary for {{ header }}</div>
            <div style="float: right; margin: 0px 0px 0px 0px;">
              <el-button @click="handleArrayToCsv()" plain><i class="mdi mdi-file-download-outline tableIcon"></i>Download CSV </el-button>
            </div>
            <div style="float: right; margin: 0px 10px 10px 0px;">
              <el-input prefix-icon="el-icon-search" size="mini" placeholder="Search Query..." type="text" class="globalSearch" v-model="filterCriteria"> </el-input>
            </div>
            <el-table :data="filterList(dxModalData, filterCriteria)" height="280px" ref="dxList">
              <el-table-column prop="codeDesc" label="Code Type" v-if="reviewType !== 'ip'">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.codeDesc, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="code" label="Code">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.code, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="description" label="Description">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.description, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="totalRecords" label="Total Instances">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.totalRecords, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="accuracyRate" label="Accuracy Rate">
                <template slot-scope="scope">
                  {{ !isNaN(scope.row.accuracyRate) ? (scope.row.accuracyRate * 100).toFixed(2) + '%' : null }}
                </template>
              </el-table-column>
            </el-table>
            <div id="accountNumberTableStats">
              <p>{{ filterList(dxModalData, filterCriteria) ? filterList(dxModalData, filterCriteria).length + ' Codes' : null }}</p>
            </div>
            <el-pagination class="pager" v-if="isIE11" background :pager-count="15" layout="prev, pager, next, slot" :page-size="itemsPerPage" :total="localDashboardAccounts.length" @current-change="handleCurrentChange" :hide-on-single-page="hideOnSinglePage" small> </el-pagination>
          </div>
        </div>
        <div v-else>
          <div v-show="isCoding">
            <div class="details-popover-title" style="float: left;text-align: left; margin: 0px 0px 10px 10px;">{{ header }}</div>
            <div style="float: right; margin: 0px 0px 0px 0px;">
              <el-button @click="handleArrayToCsv()" plain><i class="mdi mdi-file-download-outline tableIcon"></i>Download CSV </el-button>
            </div>
            <div style="float: right; margin: 0px 10px 10px 0px;">
              <el-input prefix-icon="el-icon-search" size="mini" placeholder="Search Query..." type="text" class="globalSearch" v-model="filterCriteria"> </el-input>
            </div>
            <el-table :data="isIE11 ? filterList(dashboardAccountsPagination, filterCriteria).sort(sortByOrder) : filterList(localDashboardAccounts, filterCriteria).sort(sortByOrder)" height="280px" ref="codingList">
              <el-table-column prop="patientAccountNumber" label="Pt. Number">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.patientAccountNumber, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="codingDate" label="Coding Date">
                <template slot-scope="scope">
                  <div v-html="highlightValue(formatDate(scope.row.codingDate), filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="dateOfService" label="Date of Service">
                <template slot-scope="scope">
                  <div v-html="highlightValue(formatDate(scope.row.dateOfService), filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="providerName" label="Provider">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.providerName, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="cdiName" label="CDI Staff">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.cdiName, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="consultantNumber" label="Consultant">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.consultantNumber, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="payor" label="Payor">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.payor, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="patientType" label="Pt. Type">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.patientType, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="drGorAPC" label="DRG/APC">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.drGorAPC, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="pendingReason" label="Pending Reason">
                <template slot-scope="scope">
                  <div v-html="highlightValue(scope.row.pendingReason, filterCriteria)"></div>
                </template>
              </el-table-column>
              <el-table-column prop="comments" label="Comments" width="200">
                <template slot-scope="scope">
                  <div :title="scope.row.comments" style="text-overflow: ellipsis; white-space: nowrap;" v-html="highlightValue(scope.row.comments, filterCriteria)"></div>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination class="pager" v-if="isIE11" background :pager-count="15" layout="prev, pager, next, slot" :page-size="itemsPerPage" :total="localDashboardAccounts.length" @current-change="handleCurrentChange" :hide-on-single-page="hideOnSinglePage" small> </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns'
import money from '@/mixins/money'
import { mapState, mapActions } from 'vuex'
import hiaFilters from '@/mixins/hiaFilters'
import csvGenerator from '@/mixins/csvGenerator'

// Filter configuration maps
const VALUE_KEY_MAP = {
  dx: 'code',
  px: 'code',
  hcc: 'code',
  coder: 'coder',
  coderTrending: 'coder',
  facility: 'cliName',
  drg: 'orDrg',
  patientType: 'patTypeDesc',
  reason: 'changeReason',
  serviceLine: 'clientServiceLineName',
  opdx: 'code',
  oppx: 'code',
  opcpt: 'code',
  opmod: 'code',
  ophcc: 'code',
  ophccv28: 'code',
  opCoder: 'coder',
  opCoderTrending: 'coder',
  opFacility: 'cliName',
  opServiceLine: 'clientServiceLineName',
  headerreason: 'changeReason',
  opReason: 'description',
  code: 'patTypeDesc',
  codeType: 'apc',
  proCoder: 'coder',
  proCoderTrending: 'coder',
  proProvider: 'physicianName',
  proProviderTrending: 'physicianName',
  propattype: 'patTypeDesc',
  proFacility: 'cliName',
  proheaderreason: 'changeReason',
  proServiceLine: 'clientServiceLineName',
  prodx: 'code',
  prosdoh: 'code',
  prohcc: 'code',
  prohccv28: 'code',
  procpt: 'code',
  promod: 'code',
  proem: 'code',
  proemLevelSumm: 'reason',
  proReason: 'description',
  ambCoder: 'coder',
  ambCoderTrending: 'coder',
  ambFacility: 'cliName',
  ambcode: 'patTypeDesc',
  ambReason: 'description',
  ambheaderreason: 'changeReason',
  ambdx: 'code',
  ambhcc: 'code',
  ambhccv28: 'code',
  ambcpt: 'code',
  ambmod: 'code',
  ambpx: 'code',
  ambServiceLine: 'clientServiceLineName'
}

const STAT_TYPE_MAP = {
  poaCodes: 'POA',
  cmCodes: 'Dx',
  pcsCodes: 'Px',
  cptCodes: 'CPT',
  modCodes: 'MOD',
  apcCodes: 'APC',
  emCodes: 'E/M',
  iiCodes: 'I&I',
  siCodes: 'S&I',
  cptCodesWReimb: 'CPT With Reimb',
  cptCodesWOReimb: 'CPT Without Reimb',
  hccV24AccuracyRate: 'HCC V24',
  hccV28AccuracyRate: 'HCC V28',
  accuracyRate: 'Accuracy',
  totalDRGs: 'Total DRGs',
  totalDRGNoQuery: 'Total DRG No Query',
  ipTotalCodes: 'Total Codes',
  opTotalCodes: 'Total Codes',
  proTotalCodes: 'Total Codes',
  patStatCodes: 'Patient Status',
  pooCodes: 'Point of Origin',
  reimbDiff: '',
  mainDashboardGrouping: ''
}

const TITLE_TO_FILTER_TYPE = {
  Deletions: 'deletions',
  Additions: 'additions',
  'No Recommendations': 'noRec',
  Revisions: 'revisions',
  'Reimbursement Decrease Records': 'reimbDecRecords',
  'Reimbursement Increase Records': 'reimbIncRecords',
  'Record Recommendations': 'recordRecs'
}

const REVIEW_TYPE_MAP = {
  ip: 'inpatient',
  op: 'outpatient',
  pro: 'pro'
}

export default {
  data: function() {
    return {
      loading: false,
      accountToggle: false,
      showPDF: false,
      pdfLoading: false,
      pdfLoaded: false,
      filterCriteria: '',
      currentPage: 1,
      itemsPerPage: 30,
      isIE11: !!navigator.userAgent.match(/Trident\/7\./),
      hideOnSinglePage: true
    }
  },
  name: 'DetailsPopOver',
  mixins: [money, hiaFilters, csvGenerator],
  props: {
    header: { type: String },
    popOverData: { type: Array },
    tableType: { type: String },
    reviewType: { type: String },
    statType: { type: String, default: '' },
    isCoding: { type: Boolean, default: false },
    row: { type: Object },
    rowMeta: { type: Object },
    isOpen: { type: Boolean },
    isModal: { type: Boolean, default: false }
  },
  components: {
    // pdfViewer
  },
  methods: {
    ...mapActions('dashboard/', ['GET_DASHBOARD_ACCOUNTS', 'GET_WORKSHEET_PDF_URL', 'GET_DX_DASHBOARD_BY_HCC', 'GET_DASHBOARD_ACCOUNTS_FINALIZED', 'POST_FILTER_ACCOUNTS']),
    handleViewAccountNumbers() {
      let payload = {
        reviewType: this.isCoding ? 'coding' : this.reviewType,
        accountNumbers: this.row.accountNumbers
      }
      if (this.reviewType === 'final') {
        payload.reviewType = 'final'
      }
      this.loading = true
      if (this.reviewType !== 'final') {
        this.GET_DASHBOARD_ACCOUNTS(payload).then(x => {
          this.loading = false
        })
      } else {
        payload.startDate = this.codingDateRange[0]
        payload.endDate = this.codingDateRange[1]
        this.GET_DASHBOARD_ACCOUNTS_FINALIZED(payload).then(x => {
          this.loading = false
        })
      }
    },
    handleFilterClick(clickedRow) {
      const statType = this.rowMeta.prop
      const rowType = this.rowMeta.table
      const valueKey = VALUE_KEY_MAP[rowType] || 'code'
      const isSummary = rowType === 'summary'

      if (clickedRow.title === 'Number of Records') {
        const accountPayload = {
          reviewType: this.reviewType,
          accountNumbers: this.row.accountNumbers
        }
        this.loading = true
        return this.GET_DASHBOARD_ACCOUNTS(accountPayload).then(() => {
          this.loading = false
          this.$emit('headerChange', `${isSummary ? 'Total' : this.row[valueKey] || ''} ${clickedRow.title}`.trim())
          this.$emit('tableTypeChange', 'accountNumbers')
        })
      }

      const filterType = TITLE_TO_FILTER_TYPE[clickedRow.title]
      if (!filterType || !this.row || !this.row.accountNumbers) {
        return
      }

      if (isSummary) {
        const knownAccountNumbers = [...new Set(this.row.accountNumbers.split(',').map(id => parseInt(id, 10)))]
        const apiReviewType = REVIEW_TYPE_MAP[this.reviewType] || this.reviewType

        const filterPayload = {
          filters: [{ dimension: 'reviewType', value: apiReviewType, filterType: null }, { dimension: statType, value: null, filterType: filterType }],
          knownAccountNumbers: knownAccountNumbers
        }

        this.loading = true
        this.POST_FILTER_ACCOUNTS(filterPayload)
          .then(response => {
            const filteredIds = response.data
            if (!filteredIds || !filteredIds.length) {
              this.loading = false
              return
            }

            const accountPayload = {
              reviewType: this.reviewType,
              accountNumbers: filteredIds.join(',')
            }

            return this.GET_DASHBOARD_ACCOUNTS(accountPayload).then(() => {
              this.loading = false
              const statTypeLabel = STAT_TYPE_MAP[statType] ? `${STAT_TYPE_MAP[statType]} ` : ''
              this.$emit('headerChange', `Total ${statTypeLabel}${clickedRow.title}`.trim())
              this.$emit('tableTypeChange', 'accountNumbers')
            })
          })
          .catch(error => {
            console.log('Filter accounts error:', error)
            this.loading = false
          })
        return
      }

      if (!statType || !rowType) {
        return
      }

      const knownAccountNumbers = [...new Set(this.row.accountNumbers.split(',').map(id => parseInt(id, 10)))]
      const apiReviewType = REVIEW_TYPE_MAP[this.reviewType] || this.reviewType

      const filterPayload = {
        filters: [{ dimension: 'reviewType', value: apiReviewType, filterType: null }, { dimension: statType, value: this.row.code, filterType: filterType }],
        knownAccountNumbers: knownAccountNumbers
      }

      if (this.rowMeta && this.rowMeta.codeNumber != null) {
        filterPayload.filters.splice(1, 0, { dimension: 'codeNumber', value: String(this.rowMeta.codeNumber), filterType: null })
      }

      this.loading = true
      this.POST_FILTER_ACCOUNTS(filterPayload)
        .then(response => {
          const filteredIds = response.data
          if (!filteredIds || !filteredIds.length) {
            this.loading = false
            return
          }

          const accountPayload = {
            reviewType: this.reviewType,
            accountNumbers: filteredIds.join(',')
          }

          return this.GET_DASHBOARD_ACCOUNTS(accountPayload).then(() => {
            this.loading = false
            const statTypeLabel = STAT_TYPE_MAP[statType] ? `${STAT_TYPE_MAP[statType]} ` : ''
            this.$emit('headerChange', `${this.row[valueKey]} ${statTypeLabel}${clickedRow.title}`)
            this.$emit('tableTypeChange', 'accountNumbers')
          })
        })
        .catch(error => {
          console.log('Filter accounts error:', error)
          this.loading = false
        })
    },
    isClickableTitle(title) {
      return ['No Recommendations', 'Additions', 'Deletions', 'Revisions', 'Reimbursement Decrease Records', 'Reimbursement Increase Records', 'Record Recommendations', 'Number of Records'].includes(title)
    },
    canOpenDetails(row) {
      return this.isClickableTitle(row.title) && Number(row.value) !== 0
    },
    handleDxDashboard() {
      let payload = {
        reviewType: this.isCoding ? 'coding' : this.reviewType,
        accountNumbers: this.row.accountNumbers,
        hcc: this.row.code,
        hccVersion: this.row.hccVersion
      }
      this.loading = true

      this.GET_DX_DASHBOARD_BY_HCC(payload).then(response => {
        this.loading = false
      })
    },
    handleViewWorksheets(row) {
      this.pdfLoading = true
      let id
      switch (this.reviewType) {
        case 'ip':
          id = row.drgtableId
          break
        case 'op':
          id = row.ascTableID
          break
        case 'pro':
          id = row.proRecordId
          break
      }

      let payload = {
        reviewType: this.reviewType,
        id: id
      }

      const loading = this.$loading({
        lock: true,
        text: 'Getting ready...',
        spinner: 'nucleus-loader',
        background: 'rgba(255, 255, 255, 0.7)'
      })
      this.GET_WORKSHEET_PDF_URL(payload).then(fileUrl => {
        loading.close()
        window.open(`/static/pdfjs/web/viewer.html?file=${fileUrl}`, '_blank')
      })

      // old way, fetching bytes and using blob
      // to pass to pdfjs
      // let newWindow = window.open('/static/pdfjs/web/viewer.html', '_blank')
      // this.GET_WORKSHEET(payload).then(x => {
      //   loading.close()
      //   this.openPDFViewer(newWindow, this.worksheet)
      // }, error => {
      //   loading.close()
      //   console.log(error)
      // })
    },
    // openPDFViewer(newWindow, worksheet) {
    //   var byteCharacters = atob(worksheet)
    //   var byteNumbers = new Array(byteCharacters.length)
    //   for (var i = 0; i < byteCharacters.length; i++) {
    //     byteNumbers[i] = byteCharacters.charCodeAt(i)
    //   }
    //   var byteArray = new Uint8Array(byteNumbers)
    //   var blob = new Blob([byteArray], {
    //     type: 'application/pdf'
    //   })
    //   var url = window.URL.createObjectURL(blob)
    //   var viewerUrl = '/static/pdfjs/web/viewer.html?file=' + encodeURI(url)
    //   newWindow.location.href = viewerUrl
    // },
    formatDate(date) {
      if (date) {
        return format(parseISO(date), 'MM/dd/yyyy')
      }
      return ''
    },
    accountNumberTableStats() {
      // check for totalOccurences
      return this.row.totalOccurrences ? `${this.filterList(this.localDashboardAccounts, this.filterCriteria).length} Records / ${this.row.totalOccurrences} Total Occurences` : `${this.filterList(this.localDashboardAccounts, this.filterCriteria).length} Records`
    },
    handleArrayToCsv() {
      let headers = []
      let table = null

      if (this.tableType === 'dxDashboard') {
        headers = [{ key: 'Code Type', value: 'Code Type' }, { key: 'Code', value: 'Code' }, { key: 'Description', value: 'Description' }, { key: 'Total Instances', value: 'Total Instances' }, { key: 'Accuracy Rate', value: 'Accuracy Rate' }]
        table = this.$refs.dxList.$el
        this.tableToCsv(table, 'dx_codes.csv', headers)
        return
      }

      if (this.reviewType === 'ip') {
        headers = [{ key: 'Patient Number', value: 'Patient Number' }, { key: 'Payor', value: 'Payor' }, { key: 'Discharge Date', value: 'Discharge Date' }, { key: 'Reason For Change', value: 'Reason For Change' }, { key: 'Facility DRG', value: 'Facility DRG' }, { key: 'HIA DRG', value: 'HIA DRG' }]
        table = this.$refs.ipList.$el
      } else if (this.reviewType === 'op') {
        headers = [{ key: 'Patient Number', value: 'Patient Number' }, { key: 'Patient Type', value: 'Patient Type' }, { key: 'Payor', value: 'Payor' }, { key: 'Date of Service', value: 'Date of Service' }, { key: 'Reason For Change', value: 'Reason For Change' }]
        table = this.$refs.opList.$el
      } else if (this.reviewType === 'pro') {
        headers = [{ key: 'Patient Number', value: 'Patient Number' }, { key: 'Patient Type', value: 'Patient Type' }, { key: 'Payor', value: 'Payor' }, { key: 'Date of Service', value: 'Date of Service' }, { key: 'Reason For Change', value: 'Reason For Change' }]
        table = this.$refs.opList.$el
      } else if (this.isCoding) {
        headers = [{ key: 'Pt. Number', value: 'Patient Number' }, { key: 'Coding Date', value: 'Coding Date' }, { key: 'Date of Service', value: 'Date of Service' }, { key: 'Provider', value: 'Provider' }, { key: 'CDI Staff', value: 'CDI Staff' }, { key: 'Consultant', value: 'Consultant' }, { key: 'Pt. Type', value: 'Pt. Type' }, { key: 'Payor', value: 'Payor' }, { key: 'DRG/APC', value: 'DRG/APC' }, { key: 'Pending Reason', value: 'Pending Reason' }, { key: 'Comments', value: 'Comments' }]
        table = this.$refs.codingList.$el
      }

      this.tableToCsv(table, 'account_numbers.csv', headers)
    },

    sortByOrder(a, b) {
      const aOrder = a.orderField
      const bOrder = b.orderField
      let comparison = 0
      if (aOrder > bOrder) {
        comparison = 1
      } else {
        comparison = -1
      }
      return comparison
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    getAccountData() {
      if (this.reviewType === 'ip') {
        return this.filterList(this.dashboardAccounts, this.filterCriteria, ['dschDate', 'patNum', 'payName', 'description', 'orDrg', 'neDrg']).sort(this.sortByOrder)
      } else {
        return this.filterList(this.dashboardAccounts, this.filterCriteria).sort(this.sortByOrder)
      }
    },
    handleViewPsiQmReviewAccountNumbers() {
      let payload = {
        reviewType: this.reviewType,
        accountNumbers: this.row[this.tableType]
      }
      this.loading = true
      this.GET_DASHBOARD_ACCOUNTS(payload).then(x => {
        this.loading = false
      })
    },
    getPatNumDisplay(row) {
      console.log(this.$route.name === 'my-projects')
    },
    handleLoad() {
      if ((this.isOpen || this.isModal) && this.tableType === 'accountNumbers') {
        this.handleViewAccountNumbers()
      }
      if (this.isOpen && this.tableType === 'dxDashboard') {
        this.handleDxDashboard()
      }
      if (this.isOpen && ['additionsAccounts', 'deletionsAccounts', 'noRecAccounts'].some(s => s === this.tableType)) {
        this.handleViewPsiQmReviewAccountNumbers()
      }
    }
  },
  mounted: function() {
    if (this.isModal) {
      console.log('mounted')
      this.loading = true
      this.handleLoad()
    }
  },
  computed: {
    ...mapState('dashboard/', ['dashboardData', 'dashboardProjects', 'reviewDashboardData', 'dxModalData', 'dashboardAccounts', 'worksheet', 'codingDateRange']),
    ...mapState('user/', ['currentClient', 'currentClientId']),

    localDashboardAccounts() {
      if (this.dashboardAccounts.length) {
        return this.getAccountData()
      }
      return []
    },
    dashboardAccountsPagination() {
      let length = this.localDashboardAccounts.length
      let from = length <= this.itemsPerPage ? 0 : (this.currentPage - 1) * this.itemsPerPage + 1
      let to = this.currentPage * this.itemsPerPage
      return this.localDashboardAccounts.slice(from, to)
    }
  },
  watch: {
    isOpen() {
      this.handleLoad()
    }
  }
}
</script>

<style scoped>
.viewAccountNumbers {
  margin: 0px 0px 0px 0px;
  position: absolute;
  z-index: 999;
  right: 15px;
}

.tableIcon {
  font-size: 16px;
  float: left;
  height: 12px;
  margin: -3px 5px 0 0;
}

#documentTableStats p {
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 0px 0px;
  font-size: 12px;
  font-weight: normal;
  color: #606266;
}

.details-popover-title {
  font-weight: 700;
}

/* Bold all Element table column headers in this popover (pivot, account lists, Dx summary, coding). */
.details-popover >>> .el-table thead th .cell {
  font-weight: 700 !important;
  color: #606266 !important;
}

.details {
  text-decoration: underline;
  text-decoration-style: dotted;
  cursor: pointer;
}

>>> th .cell,
>>> td .cell {
  word-break: break-word;
}
</style>
